import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { BreederLinksGetBreedsQuery, BreederLinksGetBreedsQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';

export const BREEDERLINKS_GET_BREEDS = graphql(`
  query BreederLinksGetBreeds(
    $where: DogBreedWhereInput
    $translationsWhere: DogBreedTranslationWhereInput
  ) {
    findManyDogBreed(where: $where) {
      id
      name
      sizeCategory
      baseBreedName
      translations(where: $translationsWhere) {
        id
        name
        otherNames
      }
    }
  }
`);

export const useGetBreeds = () => {
  const { language } = useRouter();

  const variables = useMemo((): BreederLinksGetBreedsQueryVariables => {
    return {
      translationsWhere: { language: { equals: language } },
      where: {
        isSubBreed: { equals: false },
        dogBreeders: {
          some: { dogBreeder: { is: { certified: { equals: true }, public: { equals: true } } } },
        },
      },
    };
  }, [language]);

  const { data, error, loading } = useQuery<
    BreederLinksGetBreedsQuery,
    BreederLinksGetBreedsQueryVariables
  >(BREEDERLINKS_GET_BREEDS, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  return {
    breeds: data?.findManyDogBreed ?? [],
    breedsError: error,
    breedsLoading: loading,
  };
};
